import React from 'react';
import { Upload, ArrowRight, Download } from 'lucide-react';
import { useApp } from './context';
import { Action, Field, PageTitle, LinkButton } from './ui';
import { QuickOrderResults } from './quickOrder/QuickOrderResults';
import { useQuickOrder, downloadTemplate } from './quickOrder/useQuickOrder';

const QuickOrderPad = () => {
  const model = useQuickOrder();
  return <div className="quick-layout">
    <form onSubmit={model.validate}>
      <div className="subheading"><h2>Bulk SKU pad</h2>
        <button type="button" className="text-link" data-testid="download-csv-template" onClick={downloadTemplate}>
          <Download size={15} />CSV template
        </button></div>
      <Field id="quick-order-text" label="SKU, quantity — one product per line" area rows={10} required
        placeholder={'sku,quantity\nBRG-6205-2RS,50\nFST-M12-SS304,500'} value={model.text}
        onChange={event => model.updateText(event.target.value)} />
      <label htmlFor="quick-csv-file" className="upload-box"><Upload size={21} />
        <span>Choose a CSV file<small>Up to 500 lines · CSV, UTF-8</small></span>
        <input id="quick-csv-file" data-testid="quick-csv-file" type="file" accept=".csv" disabled={model.busy} onChange={model.read} />
      </label>
      {model.error && <div className="notice error" data-testid="quick-order-error" role="alert">{model.error}</div>}
      <Action id="validate-skus" busy={model.busy} type="submit">Validate SKUs <ArrowRight size={16} /></Action>
    </form>
    <QuickOrderResults rows={model.rows} addToRequest={model.addToRequest} />
  </div>;
};

const QuickOrderAccess = ({ user }) => {
  const allowed = user?.approval === 'approved' && user.role === 'buyer';
  if (allowed) return <QuickOrderPad />;
  return <div className="notice" data-testid="quick-order-auth-notice">
    <p>An approved buyer account is required for quick ordering.</p>
    <LinkButton to={user ? '/workspace' : '/auth'} id="quick-signin">{user ? 'View business account' : 'Sign in'}</LinkButton>
  </div>;
};

export default function QuickOrder() {
  const { user } = useApp();
  return <div className="container quick-page">
    <PageTitle eyebrow="LESS ADMIN. MORE BUSINESS." title="Your entire list. One request.">
      Add your SKUs and quantities to start a bulk sourcing request.
    </PageTitle>
    <QuickOrderAccess user={user} />
  </div>;
}